export class TankLog {
  iPlaceId: string;
  tankId: string;
  localTankId: string;
  name: string;
  temperature: number;
  productVolume: number;
  waterVolume: number;
  waterHeight: number;
  ingestionDate: number;
  updated: number;
}
